var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransactions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 23.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5,0H3.5A3.47,3.47,0,0,0,1,1.05a.38.38,0,0,0-.14.14A3.51,3.51,0,0,0,0,3.5v13a4.49,4.49,0,0,0,3.31,4.17L14.47,23.3a3.35,3.35,0,0,0,.76.09A2.75,2.75,0,0,0,17,22.81,2.87,2.87,0,0,0,18,20.5V18h2.5A3.5,3.5,0,0,0,24,14.5V3.5A3.5,3.5,0,0,0,20.5,0ZM17,20.5a1.79,1.79,0,0,1-2.31,1.83L3.53,19.7A3.5,3.5,0,0,1,1,16.5V3.5A2.44,2.44,0,0,1,1.49,2l13,3.24A3.56,3.56,0,0,1,17,8.5Zm6-6A2.5,2.5,0,0,1,20.5,17H18V9h1.5a.5.5,0,0,0,0-1H18a4.58,4.58,0,0,0-3.24-3.71L13.56,4H19.5a.5.5,0,0,0,0-1H9.56L2.46,1.23A2.43,2.43,0,0,1,3.5,1h17A2.5,2.5,0,0,1,23,3.5ZM13,11a2.5,2.5,0,1,0,2.5,2.5A2.5,2.5,0,0,0,13,11Zm0,4a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,13,15Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactions);
export default __webpack_public_path__ + "static/media/transactions.be3be3aeb5445c329126cbf9807bdc78.svg";
export { ForwardRef as ReactComponent };